import { DateField } from '@mews-commander/form';
import { createZodFormResolver, useFormControls, DateTimeUtils } from '@mews/framework';
import { StructuredDate } from '@optimus-web/core';
import { useCalendarService } from '@mews-commander/ui';
import { createFilterSchema, TrialBalanceFilterSchema, TrialBalanceFilterKeys } from '../utils/filterSchema';

interface TrialBalanceTableRightSideProps {
    minDate?: StructuredDate;
    maxDate?: StructuredDate;
    controlledDate?: StructuredDate;
    onDateChange?: (a?: StructuredDate) => void;
}

export const TrialBalanceTableRightSide = ({
    minDate,
    maxDate,
    controlledDate,
    onDateChange,
}: TrialBalanceTableRightSideProps) => {
    const calendarService = useCalendarService();

    const { renderFormContent, reset, submit } = useFormControls<TrialBalanceFilterSchema>({
        id: 'trial-balance-date',
        defaultValues: { trialBalanceDate: controlledDate ? calendarService.toISOString(controlledDate) : undefined },
        mode: 'onChange',
        onSubmit: ({ trialBalanceDate }) => {
            if (!trialBalanceDate) {
                return;
            }
            onDateChange?.(DateTimeUtils.dateIsoStringToStructureDate(trialBalanceDate));
        },
        resolver: createZodFormResolver(
            createFilterSchema({
                minDate,
                maxDate,
                calendarService,
            })
        ),
    });

    return renderFormContent(
        <DateField
            name={TrialBalanceFilterKeys.trialBalanceDate}
            aria-label={TrialBalanceFilterKeys.trialBalanceDate}
            clearable
            minDate={minDate}
            maxDate={maxDate}
            mode="iso"
            onDateChange={async () => submit()}
            onClear={() => {
                reset();
                onDateChange?.(undefined);
            }}
            dateValue={controlledDate}
            dataTestId={TrialBalanceFilterKeys.trialBalanceDate}
        />
    );
};
